<template>
  <div class="details-reader-array">
    <span class="details-reader__label app-key-value__key">
      {{ detailsKey | readableCamelCase | formatCommonAbbreviations }}:
    </span>

    <div class="details-reader__row">
      <div
        v-for="(item, id) in detailsValue"
        :key="`${_uid}-${id}-${detailsKey}`"
      >
        <template v-if="isArray(item) || isObject(item)">
          <details-reader
            :with-accordion="withAccordion"
            :copyable="copyable"
            :shortable="shortable"
            :formatters="formatters"
            :details="item" />
        </template>

        <template v-else>
          <span class="details-reader-array__item">{{ item }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'details-reader-array',

  components: {
    DetailsReader: () => import('./DetailsReader'),
  },
  props: {
    detailsKey: {
      type: [String],
      required: true,
    },
    detailsValue: {
      type: [Array],
      required: true,
    },
    withAccordion: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    shortable: {
      type: Boolean,
      default: false,
    },
    formatters: {
      type: [Array],
      default: () => [],
    },
  },
  methods: {
    isArray (value) {
      return Array.isArray(value)
    },

    isObject (value) {
      return value && typeof value === 'object'
    },
  },
}
</script>

<style lang="scss">
@import './details-reader';
</style>
